import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-what-new-detail',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './what-new-detail.component.html',
  styleUrl: './what-new-detail.component.css'
})
export class WhatNewDetailComponent {

  baseApiUrl = environment.baseApiUrl;

} 
